export const types = {
  TEXT: 0,
  IMAGE: 1,
}
